import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import arrowUp from "../../assets/images/myImages/arrow-trending-up.webp";
import arrowDown from "../../assets/images/myImages/arrow-trending-down.webp";
import reportUp from "../../assets/images/myImages/reports.webp";
import reportDown from "../../assets/images/myImages/reports (1).webp";
import chartIcon from "../../assets/images/myImages/alignbottom.webp";
import doughnut from "../../assets/images/myImages/donut-chart.webp";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { numberWithCommas } from "../../util/formatNumber";

let wsURL: any = "";

const wsUrlDev = `ws://itexpay-admin-alb-staging-133804970.us-west-2.elb.amazonaws.com:8080/monitor/trans`;

const wsUrlProd = "wss://admin-ws.itexpay.com/monitor/trans";

const MonitorTransactions = () => {
	const dispatch = useDispatch();
	const [transactions, setTransactions] = useState<any>();

	if (
		window.location.href.includes("admin.itexpay.com-staging-env") ||
		window.location.href.includes("localhost")
	) {
		wsURL = wsUrlDev;
	} else {
		wsURL = wsUrlProd;
	}

	let ws: WebSocket | null = null;

	const connectWebSocket = (): void => {
		ws = new WebSocket(wsURL);

		ws.onopen = () => {
			console.log("connected", new Date().toLocaleTimeString());
		};

		ws.onmessage = (event: MessageEvent) => {
			if (event) {
				const { data } = JSON.parse(event?.data);
				if (data) {
					setTransactions(data);
				}
			}
		};

		ws.onclose = () => {
			// Try to reconnect after a short delay
			setTimeout(() => {
				connectWebSocket();
			}, 100); // Adjust the delay as needed
		};
	};

	const getMonitorTransactions = async () => {
		dispatch(openLoader());
		try {
			const response: any = await axios.get(`v1/monitor/transaction/live`);
			setTransactions(response?.data);
		} catch (err: any) {
			dispatch(closeLoader());
			dispatch(
				openToastAndSetContent({
					toastContent:
						err.response?.data?.message ||
						err?.data?.message ||
						err?.message ||
						err,
					toastType: "error",
				})
			);
		} finally {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		connectWebSocket();

		// Clean up the WebSocket connection and mounted flag when the component unmounts
		return () => {
			if (ws) {
				ws.close();
			}
		};
	}, []);

	useEffect(() => { }, [transactions]);

	useEffect(() => {
		getMonitorTransactions();
	}, []);

	const totalTrans = {
		title: "Total transactions",
		img: chartIcon,
		total: transactions?.transactionSummary[0]?.total
			? `${transactions?.transactionSummary[0]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[0]?.total
			)}`
			: 0,
		percent: transactions?.transactionSummary[0]?.total_count || 0,
		arrowImg: arrowUp,
		bg: "rgba(98, 184, 228, 0.15)",
		amount: "$ 30,000",
		usdPerc: "20",
	};

	const successTrans = {
		title: "Successful transactions",
		img: reportUp,
		total: transactions?.transactionSummary[0]?.currency
			? `${transactions?.transactionSummary[0]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[0]?.success
			)}`
			: 0,
		percent: transactions?.transactionSummary[0]?.success_count || 0,
		arrowImg: arrowUp,
		bg: "rgba(22, 163, 63, 0.15)",
		amount: "$ 20,000",
		usdPerc: "16",
	};

	const failedTrans = {
		title: "Failed transactions",
		img: reportDown,
		total: transactions?.transactionSummary[0]?.currency
			? `${transactions?.transactionSummary[0]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[0]?.failed
			)}`
			: 0,
		percent: transactions?.transactionSummary[0]?.failed_count || 0,
		arrowImg: arrowDown,
		bg: "rgba(235, 87, 87, 0.15)",
		amount: "$ 8,000",
		usdPerc: "10",
	};

	const pendingTrans = {
		title: "Pending transactions",
		img: doughnut,
		total: transactions?.transactionSummary[0]?.currency
			? `${transactions?.transactionSummary[0]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[0]?.pending
			)}`
			: 0,
		percent: transactions?.transactionSummary[0]?.pending_count || 0,
		arrowImg: arrowUp,
		bg: "rgba(232, 187, 0, 0.15)",
		amount: "$ 2,000",
		usdPerc: "16",
	};

	const totalTransUsd = {
		title: "Total transactions",
		img: chartIcon,
		total: transactions?.transactionSummary[1]?.total
			? `${transactions?.transactionSummary[1]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[1]?.total
			)}`
			: 0,
		percent: transactions?.transactionSummary[1]?.total_count || 0,
		arrowImg: arrowUp,
		bg: "rgba(98, 184, 228, 0.15)",
		amount: `$ ${transactions?.transactionSummary[1]?.total || "0"}`,
		usdPerc: "20",
	};

	const successTransUsd = {
		title: "Successful transactions",
		img: reportUp,
		total: transactions?.transactionSummary[1]?.currency
			? `${transactions?.transactionSummary[1]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[1]?.success
			)}`
			: 0,
		percent: transactions?.transactionSummary[1]?.success_count || 0,
		arrowImg: arrowUp,
		bg: "rgba(22, 163, 63, 0.15)",
		amount: `$ ${transactions?.transactionSummary[1]?.success || "0"}`,
		usdPerc: "16",
	};

	const failedTransUsd = {
		title: "Failed transactions",
		img: reportDown,
		total: transactions?.transactionSummary[1]?.currency
			? `${transactions?.transactionSummary[1]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[1]?.failed
			)}`
			: 0,
		percent: transactions?.transactionSummary[1]?.failed_count || 0,
		arrowImg: arrowDown,
		bg: "rgba(235, 87, 87, 0.15)",
		amount: `$ ${transactions?.transactionSummary[1]?.failed || "0"}`,
		usdPerc: "10",
	};

	const pendingTransUsd = {
		title: "Pending transactions",
		img: doughnut,
		total: transactions?.transactionSummary[1]?.currency
			? `${transactions?.transactionSummary[1]?.currency} ${numberWithCommas(
				transactions?.transactionSummary[1]?.pending
			)}`
			: 0,
		percent: transactions?.transactionSummary[1]?.pending_count || 0,
		arrowImg: arrowUp,
		bg: "rgba(232, 187, 0, 0.15)",
		amount: `$ ${transactions?.transactionSummary[1]?.pending || "0"}`,
		usdPerc: "16",
	};

	const Card = ({ data, id }: any) => {
		const red = Number(data.percent) < 15;

		const img = red ? arrowDown : arrowUp;
		// const detail = id === "usd" ? data.amount : data.total;
		const detail = data.total;

		return (
			<div className={styles.card}>
				<div className={styles.cardTop}>
					<span style={{ background: data.bg }}>
						<img src={data.img} alt="icon" />
					</span>
					<p>{data.title}</p>
				</div>
				<div className={styles.margin}>
					<h2>{detail}</h2>
					<div className={styles.realTime}>
						<p>Count</p>
						<span
							style={{ color: "#fff", fontSize: "0.8em" }}
						>{`${data.percent}`}</span>
					</div>
				</div>
			</div>
		);
	};

	const CardBox = ({ id }: any) => {
		return (
			<div className={styles.cardHolder}>
				{id === "ngn" && <Card data={totalTrans} id={id} />}
				{/* Display NGN total transactions */}
				{id === "usd" && <Card data={totalTransUsd} id={id} />}
				{/* Display USD total transactions */}
				<Card data={id === "usd" ? successTransUsd : successTrans} id={id} />
				<Card data={id === "usd" ? failedTransUsd : failedTrans} id={id} />
				<Card data={id === "usd" ? pendingTransUsd : pendingTrans} id={id} />
			</div>
		);
	};

	return (
		<div className={styles.flexBox}>
			<div className={styles.firstBox}>
				<div className={styles.topSection}>
					<span className={styles.headerText}>
						Transaction Monitoring System
					</span>
				</div>
				<div className={styles.summary}>
					<h1>Transaction Summary</h1>
					<p>
						See total, successful, pending and failed transactions in real-time
					</p>
				</div>
				<h3 className={styles.h3}>
					{transactions?.transactionSummary[0]?.currency}
				</h3>

				<CardBox id="ngn" />
				{transactions?.transactionSummary?.length > 1 && (
					<>
						<h3 className={styles.h3}>
							{transactions?.transactionSummary[1]?.currency}
						</h3>
						<CardBox id="usd" />
					</>
				)}
			</div>
			<div className={styles.secondBox}>
				<div className={styles.summary}>
					<h1>Top Response Codes</h1>
					<p>See the top reasons for failure in real-time</p>
				</div>
				{transactions?.topFailureStatus?.map((resp: any, i: number) => (
					<div key={i} className={styles.problems}>
						<div>
							<h6>{resp.count}</h6>
							<p>{resp.responsemessage || "No error code found"} </p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default MonitorTransactions;
